import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';
import { DurationComponent } from '@camelot/ui';

import { CamTranslationGrid } from '../../../translation.service';
import { AbstractCellComponent } from '../../abstract';

/**
 * Ces cellules n'ont pas de selector et partagent la même forme (mêmes inputs/outputs, même
 * nombre de noeuds). L'ID de composant généré par Angular n'inclut ni le nom de classe ni le
 * corps du template : sans discriminant elles produisent le même ID et Angular émet NG0912.
 * L'attribut d'hôte ci-dessous force un ID distinct pour chacune.
 */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  host: { 'data-cell': 'date' },
  template: `@if (this.value) {
    {{ this.value | date: 'shortDate' }}
  }`,
  imports: [DatePipe],
})
export class GridDateCellComponent extends AbstractCellComponent<any, string> {}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  host: { 'data-cell': 'date-time' },
  template: `@if (this.value) {
    {{ this.value | date: 'short' }}
  }`,
  imports: [DatePipe],
})
export class GridDateTimeCellComponent extends AbstractCellComponent<any, string> {}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  host: { 'data-cell': 'time' },
  imports: [DurationComponent],
  template: `@if (this.time) {
    <div class="align-center" style="height: 100%">
      <cam-duration [startDate]="this.time"></cam-duration>
    </div>
  }`,
})
export class GridTimeCellComponent extends AbstractCellComponent<any, string> {
  get time() {
    return this.value;
  }
}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  host: { 'data-cell': 'hour' },
  template: `@if (this.value) {
    {{ this.value | date: 'HH:mm' }}
  }`,
  imports: [DatePipe],
})
export class GridHourCellComponent extends AbstractCellComponent<any, string> {}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  host: { 'data-cell': 'day-of-the-week' },
  template: `@if (this.value) {
    {{ 'ag-grid.template.dayoftheweek.' + this.value | translate }}
  }`,
  imports: [TranslatePipe],
})
export class GridDayOfTheWeekCellComponent extends AbstractCellComponent<any, string> {
  constructor() {
    super();
    CamTranslationGrid.getInstance();
  }
}
